// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-lang.scss
 ** module id = 54
 ** module chunks = 0 1
 **/